import React from 'react';
import { DialogText } from '../../styles/DialogStyles';
import styles from './WeeklyBreakdown.module.css';

interface Props {
  productName: string;
  skuPrice: string;
  weeklyTermPeriod: number;
  weeklyTermMessage: string;
  weeklyPrice: string;
}

function WeeklyBreakdown(props: Props) {
  const { productName, skuPrice, weeklyTermPeriod, weeklyTermMessage, weeklyPrice } = props;

  return (
    <div className={styles.container}>
      <DialogText
        data-testid="weekly-breakdown-product-name"
        size="m1"
        tag="h3"
        type="heading"
        dangerouslySetInnerHTML={{
          __html: productName,
        }}
      />

      <DialogText data-testid="weekly-breakdown-sku-price" size="m1" tag="p" type="paragraph">
        {skuPrice}
      </DialogText>

      <DialogText data-testid="weekly-breakdown-weekly-term-message" size="m1" tag="p" type="paragraph">
        <strong>{weeklyTermPeriod} weeks</strong> {weeklyTermMessage}
      </DialogText>

      <DialogText data-testid="weekly-breakdown-weekly-price" size="m1" tag="p" type="paragraph">
        <strong>{weeklyPrice}</strong> per week
      </DialogText>
    </div>
  );
}

export default WeeklyBreakdown;
